import React, { useCallback, useContext, useEffect, useState } from "react";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { getDataFromApi } from "../../../../APIs";
import { filterDataContext } from "../../../../App";
import {
  ChangeSportTypeforApi,
  chipDateShow,
  formatDate,
  getFilteredEvents,
  getPopularApiByTabs,
  getSearchApiByTabs,
  priceRangeShow,
} from "../../../../utils/func";
import {
  CITIES_API,
  EVENTS_API,
  POPULARVENUES_API,
  VENUES_API,
} from "../../../../constants";
import FilterChip from "../../../FilterChip";
import LocationSorting from "../Location";
import SearchBar from "../SearchBar";
import ChipsSec from "../ChipsSec";
import { countriesList } from "../../../../constants/TextContainer";
import { EVENTSPAGE } from "../../../../constants/RoutingPath";
import { createSearchParams, useNavigate } from "react-router-dom";
import ResultChip from "../../../ResultChip";

const SortingMenu = ({
  currentSortingTab,
  setShowSorting,
  showSorting,
  setSearchParams,
  searchParams,
}) => {
  const {
    filteredParams,
    selectedSport,
    filteredEvents,
    preLoadVenues,
    preLoadCities,
    preloadTournamentData,
    filterChips,
    setFilterChips,
    popularData,
    setPopularData,
    searchResult,
    setSearchResult,
    filterSearchInput,
    setFilterSearchInput,
    setCurrentSortingTab,
    setFilterLoader,
  } = useContext(filterDataContext);
  const [loader, setLoader] = useState(false);

  const navigate = useNavigate();

  //According to Sorting Tabs
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (filterSearchInput.trim() !== "") {
        getSearchResult();
      }
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [filterSearchInput, selectedSport, currentSortingTab]);

  //PopularApi Data
  useEffect(() => {
    let getApiForPopular = getPopularApiByTabs(currentSortingTab);
    if (getApiForPopular.length > 0) {
      getPopularData(getApiForPopular);
    } else {
      setPopularData([]);
    }
    if (currentSortingTab === "Location") {
      getFilteredPopularVenues();
    }
    setFilterSearchInput("");
  }, [selectedSport, currentSortingTab]);

  const getTournamentNameFromSlug = (value) => {
    if (preloadTournamentData) {
      const getTournamentName = preloadTournamentData?.filter((item) => {
        return item.slug === value;
      });
      if (getTournamentName.length > 0) {
        return getTournamentName[0]?.official_name;
      }
    }
  };

  useEffect(() => {
    const CreateFilterChips = () => {
      let selectedChips = [];
      let date_start = "";
      let date_stop = "";
      let min_Price = "";
      let max_price = "";
      filteredParams.forEach((item) => {
        if (item.key === "team_name") {
          selectedChips.push({ key: item.key, value: item.value });
        } else if (item.key === "tournament_name") {
          let tournamentName = getTournamentNameFromSlug(item.value);
          selectedChips.push({ key: item.key, value: tournamentName });
        } else if (item.key === "country") {
          selectedChips.push({
            key: item.key,
            value: getCountryName(item.value),
          });
        } else if (item.key === "city") {
          selectedChips.push({ key: item.key, value: item.value });
        } else if (item.key === "venue") {
          selectedChips.push({ key: item.key, value: item.value });
        } else if (item.key === "date_start") {
          date_start = item.value;
        } else if (item.key === "date_stop") {
          date_stop = item.value;
        } else if (item.key === "minPrice") {
          min_Price = item.value;
        } else if (item.key === "maxPrice") {
          max_price = item.value;
        } else if (item.key === "ticket_Availability") {
          selectedChips.push({
            key: item.key,
            value:
              item.value <= 1
                ? `${item.value} ticket`
                : `${item.value} tickets`,
          });
        }
      });
      if (date_start || date_stop) {
        selectedChips.push({
          key: "date",
          value: chipDateShow(date_start, date_stop),
        });
      }
      if (min_Price || max_price) {
        selectedChips.push({
          key: "price",
          value: priceRangeShow(min_Price, max_price),
        });
      }
      setFilterChips(selectedChips);
    };
    CreateFilterChips();
  }, [filteredParams, searchParams]);

  const getAndSetData = async (url) => {
    setFilterLoader(true);
    const result = await getDataFromApi(
      currentSortingTab === "Location"
        ? url
        : url + `&sport_type=${selectedSport}`
    );
    setFilterLoader(false);
    if (result) {
      return result.data.data;
    }
    return [];
  };

  const getCountryName = (value) => {
    let filteredCountry = countriesList.filter((item) => {
      return item.iso === value;
    });
    return filteredCountry[0].country_name;
  };

  const createFilterParams = (item) => {
    setFilterSearchInput("");
    searchParams.delete("page");
    const paramsToUpdate = {};
    if (item.official_name && item.team_id) {
      paramsToUpdate.team_name = item.official_name;
    }
    if (item.official_name && item.tournament_id) {
      paramsToUpdate.tournament_name = item.slug;
    }

    if (item.country_name || item.city_Name || item.venueFilter_id) {
      searchParams.delete("country");
      searchParams.delete("city");
      searchParams.delete("venue");
      if (item.country_name) paramsToUpdate.country = item.iso;
      if (item.city_Name) paramsToUpdate.city = item.city_Name;
      if (item.venueFilter_id) paramsToUpdate.venue = item.venue_Name;
    }

    if (item.date) {
      if (item.date.includes("/")) {
        const [date_start, date_stop] = item.date.split("/");
        paramsToUpdate.date_start = date_start;
        paramsToUpdate.date_stop = date_stop;
      } else {
        searchParams.delete("date_stop");
        paramsToUpdate.date_start = item.date;
      }
    }
    if (item.price || item.minPriceInput || item.maxPriceInput) {
      if (item.price) {
        const [minPrice, maxPrice] = item.price.split("/");
        paramsToUpdate.minPrice = minPrice;
        paramsToUpdate.maxPrice = maxPrice;
      }
      if (item.minPriceInput) {
        searchParams.delete("maxPrice");
        paramsToUpdate.minPrice = item.minPriceInput;
      }
      if (item.maxPriceInput) {
        paramsToUpdate.minPrice = 0;
        paramsToUpdate.maxPrice = item.maxPriceInput;
      }
    }
    if (item.tickets_Avalability) {
      paramsToUpdate.ticket_Availability = item.tickets_Avalability;
    }

    for (const [key, value] of Object.entries(paramsToUpdate)) {
      if (value !== undefined) {
        searchParams.set(key, value);
      }
    }
    setSearchParams(searchParams);
  };

  const getSearchResult = () => {
    if (
      currentSortingTab !== "Date" &&
      currentSortingTab !== "Location" &&
      currentSortingTab !== "Availability"
    ) {
      getAndSetData(
        getSearchApiByTabs(currentSortingTab) + filterSearchInput
      ).then(setSearchResult);
    }
  };

  const getFilteredPopularVenues = async () => {
    setFilterLoader(true);
    let popularVenues = await getDataFromApi(POPULARVENUES_API);
    setFilterLoader(false);
    if (popularVenues) {
      let filteredVenues = popularVenues.data.data.map((item) => ({
        city: item.city,
        country: item.country,
        venue_Name: item.official_name,
        venueFilter_id: item.venue_id,
      }));
      filteredVenues && setPopularData(filteredVenues);
    } else {
      setPopularData([]);
    }
  };

  const getPopularData = async (url) => {
    let popularData = await getAndSetData(url);
    if (popularData) {
      setPopularData(popularData);
    }
  };

  const handleOpenEvent = (eventName) => {
    navigate({
      pathname: `/ticket/${eventName}`,
    });
  };

  const setSortingTabFromChips = (key) => {
    if (key === "team_name") {
      setCurrentSortingTab("Team");
    } else if (key === "venue" || key === "city" || key === "country") {
      setCurrentSortingTab("Location");
    } else if (key === "date") {
      setCurrentSortingTab("Date");
    } else if (key === "ticket_Availability") {
      setCurrentSortingTab("Availability");
    } else if (key === "price") {
      setCurrentSortingTab("Price-Range");
    } else if (key === "tournament_name") {
      setCurrentSortingTab("Competition");
    }
  };

  return (
    <div className="search_anad_result">
      <div className="filter_container">
        {filteredParams.length > 0 && (
          <div className="upper_chips">
            {filterChips.map((item, index) => {
              return (
                <FilterChip
                  name={item.value}
                  searchParams={searchParams}
                  setSearchParams={setSearchParams}
                  key={index}
                  removeKey={item.key}
                  setSortingTabFromChips={setSortingTabFromChips}
                />
              );
            })}
          </div>
        )}
        <SearchBar
          currentSortingTab={currentSortingTab}
          createFilterParams={createFilterParams}
          filterSearchInput={filterSearchInput}
          setFilterSearchInput={setFilterSearchInput}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setSortingTabFromChips={setSortingTabFromChips}
        />

        {filterSearchInput.length === 0 && filteredParams.length > 0 ? (
          <div className="results">
            <div className="popular_teams common_class">
              <h3>Events</h3>
              <ChipsSec
                filteredEvents={filteredEvents}
                createFilterParams={createFilterParams}
                currentSortingTab={currentSortingTab}
                setShowSorting={setShowSorting}
                showSorting={showSorting}
                setSearchParams={setSearchParams}
                searchParams={searchParams}
                handleOpenEvent={handleOpenEvent}
              />
            </div>
          </div>
        ) : (
          <div className="results">
            {filterSearchInput.length === 0 ? (
              currentSortingTab === "Team" ||
              currentSortingTab === "Competition" ||
              currentSortingTab === "Location" ? (
                popularData.length > 0 && (
                  <div className="popular_teams common_class">
                    <h3>
                      Showing Popular {currentSortingTab}
                      <FontAwesomeIcon icon={faStar} />
                    </h3>
                    <ChipsSec
                      popularData={popularData}
                      createFilterParams={createFilterParams}
                      currentSortingTab={currentSortingTab}
                    />
                  </div>
                )
              ) : (
                ""
              )
            ) : (
              <>
                {currentSortingTab === "Location" && (
                  <LocationSorting
                    filterSearchInput={filterSearchInput}
                    createFilterParams={createFilterParams}
                    citiesData={preLoadCities}
                    venuesData={preLoadVenues}
                    setPopularData={setPopularData}
                    perPage={10}
                  />
                )}
                {currentSortingTab !== "Location" && (
                  <ChipsSec
                    searchResult={searchResult}
                    createFilterParams={createFilterParams}
                    currentSortingTab={currentSortingTab}
                    setSearchResult={setSearchResult}
                  />
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SortingMenu;
